import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { FireAndFlowerFiveBySevenBackgroundViewModel } from './fire-and-flower-five-by-seven-background-view-model';
import { GroupedByBrandShelfTalkerCardData } from '../../../../../../../models/shelf-talkers/grouped-by-brand-shelf-talker-card-data';

@Component({
  selector: 'app-fire-and-flower-five-by-seven-background',
  templateUrl: './fire-and-flower-five-by-seven-background.component.html',
  styleUrl: './fire-and-flower-five-by-seven-background.component.scss',
  providers: [FireAndFlowerFiveBySevenBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireAndFlowerFiveBySevenBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: FireAndFlowerFiveBySevenBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: GroupedByBrandShelfTalkerCardData;
}
